import React from 'react';
import './LoadingDots.scss';

const LoadingDots = () => {
  return (
    <div className="loading-dots">
      <span className="dot"></span>
      <span className="dot"></span>
      <span className="dot"></span>
    </div>
  );
};

export default LoadingDots;